export { default } from './loyalty-dashboard';
